
        // Import authentication modules with error handling
        async function initializeAuth() {
            try {
                const authModule = await import('./auth.js');
                const authUIModule = await import('./auth-ui.js');

                // Initialize authentication
                await authModule.initAuth();

                // IMPORTANT: Set up global functions BEFORE initializing UI
                // This ensures they're available when auth-ui tries to sync pending signatures

                // Make saveSignature available globally for desktop.js
                window.saveSignatureToCloud = async (gifBlob, metadata) => {
                    if (authModule.isAuthenticated()) {
                        try {
                            return await authModule.saveSignature(gifBlob, metadata);
                        } catch (error) {
                            console.error('Error saving signature to cloud:', error);
                        }
                    }
                    return null;
                };

                // Make getUserSignatures available globally
                window.getCloudSignatures = async () => {
                    if (authModule.isAuthenticated()) {
                        try {
                            return await authModule.getUserSignatures();
                        } catch (error) {
                            console.error('Error getting cloud signatures:', error);
                        }
                    }
                    return [];
                };

                // Make isAuthenticated available globally
                window.isUserAuthenticated = () => {
                    return authModule.isAuthenticated();
                };

                // Make deleteAllSignatures available globally
                window.deleteAllCloudSignatures = async () => {
                    if (authModule.isAuthenticated()) {
                        try {
                            return await authModule.deleteAllSignatures();
                        } catch (error) {
                            console.error('Error deleting all signatures:', error);
                            throw error;
                        }
                    }
                    return false;
                };

                // NOW initialize the auth UI (after global functions are set up)
                await authUIModule.initAuthUI();
            } catch (error) {
                console.warn('Authentication module not loaded. Running without authentication features.');
                console.warn('To enable authentication, follow these steps:');
                console.warn('1. Add your Supabase credentials to the script at the top of this file');
                console.warn('2. Use "npm run dev" to start the development server');
                console.warn('3. Or add your Supabase credentials to the window variables above');
            }
        }

        // Stabilize and reveal UI once everything is ready
        async function revealUI() {
            // Wait for CSS to be fully loaded
            await new Promise((resolve) => {
                const checkCSS = () => {
                    if (document.documentElement.getAttribute('data-css-loaded') === 'true') {
                        resolve();
                    } else {
                        requestAnimationFrame(checkCSS);
                    }
                };
                checkCSS();
            });

            // Preload critical SVG images to prevent FOUC
            await new Promise((resolve) => {
                const xMarkImg = new Image();
                xMarkImg.onload = resolve;
                xMarkImg.onerror = resolve; // Resolve even on error to not block UI
                xMarkImg.src = 'assets/X_marksthespot.svg';
            });

            // Wait for authentication UI to be fully initialized
            await initializeAuth();

            // Force layout calculation by reading offsetHeight
            // This ensures all DOM changes are applied before revealing
            document.body.offsetHeight;

            // Use requestAnimationFrame to ensure browser has painted
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    // Remove loading classes and reveal UI
                    const isMobileDevice = 'ontouchstart' in window;
                    document.body.classList.remove('mobile-loading');
                    document.body.classList.remove('ui-loading');
                    document.body.classList.add('ui-ready');
                });
            });
        }

        // Start initialization
        revealUI();

        // Load the appropriate script dynamically
        const isMobileDevice = 'ontouchstart' in window;
        const jsFile = isMobileDevice ? 'mobile.js' : 'desktop.js';
        const script = document.createElement('script');
        script.type = 'module';
        script.src = jsFile;
        document.body.appendChild(script);
    